var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"pb-2"},[_c('b-col',[_c('app-detalhe',{attrs:{"titulo":"Total Hs CT","xl":_vm.xl}},[_c('strong',[_vm._v(_vm._s(_vm.item.campoLivre1))])]),_c('app-detalhe',{attrs:{"titulo":"Saldo Hs Ant","xl":_vm.xl}},[_c('strong',[_vm._v(_vm._s(_vm.item.campoLivre2))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }